import _ from 'lodash'
import React from 'react';
import { ROOT_URL, API_URL, DELIVERY_COST, DELIVERY_THRESHOLD } from '../config';
import accounting from 'accounting';
import moment from 'moment';
import { canUseWebP } from 'react-img-webp';
import * as QueryString from "query-string"
import slugify from 'slugify';
import { isCookieCategoryAllowed } from '../utils/cookieConsent';

export function getRoute(path) {
    return API_URL + path;
}

export function fetchMaterial(filter, sort, page, limit, options = null) {
    const body = {
        filter: filter,
        sort: sort,
        page: page,
        limit: limit,
        options: options,
    }
    return fetch(getRoute(`/api/v2/materials`), {
        method: 'post',
        accept: 'application/json',
        body: JSON.stringify(body),
        credentials: 'include',
        headers: {
            'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
    })
}

export function fetchCoupon(filter = {}, sort = {}, page = 1, user_id = null, limit = 12) {
    let l = limit;
    if (Array.isArray(_.get(filter, "coupon_id", null))) {
        l = filter.coupon_id.length;
    }
    return fetch(getRoute(`/api/get_coupons`), {
        method: 'post',
        accept: 'application/json',
        body: JSON.stringify({ filter, sort, page, option: { user_id }, limit: l }),
        credentials: 'include'
    })
}

export function generateOrderToken(so_no) {
    return fetch(getRoute('/order/token/generate'), {
        method: 'post',
        accept: 'application/json',
        body: JSON.stringify({ so_no }),
        credentials: 'include'
    })
}

export function getName(profile, censor = false) {
    if (!profile) return "";
    if (typeof profile.alias !== "undefined" && profile.alias !== null && profile.alias.trim() !== "") {
        return profile.alias;
    }
    else if (typeof profile.first_name !== "undefined" && profile.first_name !== null & profile.last_name !== null) {
        const firstName = profile.first_name ? (censor ? profile.first_name.substr(0, 2) + "*****" : profile.first_name) : "";
        const lastName = profile.last_name ? (censor ? profile.last_name.substr(0, 2) + "*****" : profile.last_name) : "";
        let name = firstName + " " + lastName;
        name = name.trim();
        if (name !== "") {
            return name;
        }
    }
    else if (typeof profile.email !== "undefined" && profile.email !== null) {
        return profile.email.split('@')[0];
    }
}

export function getProfileImage(profile) {
    return profile.fb_img ? profile.fb_img : ROOT_URL + profile.img_profile;
}

export function moneyFormat(money, symbol = "", precision = 2) {
    let amount = money;
    if (money === null) {
        amount = 0;
        // return "0.00 ฿";
    }
    let result = accounting.formatMoney(amount, { symbol: symbol, format: "%s %v" }, precision);
    if (precision === 0) {
        result = result.substr(0, result.length - 3);
    }
    return result;
}

export function displayText(value, texts = []) {
    if (typeof value !== "undefined" && value !== null) {
        return value + (Array.isArray(texts) ? texts.join('') : texts);
    }
    return '';
}

export function twoDigit(n) {
    return n > 9 ? n : "0" + n;
}

export function computeDeliveryCost(total, discount, deliveryRates = null) {
    // If deliveryRates is provided, use dynamic calculation
    if (deliveryRates && deliveryRates.length > 0) {
        const subtotal = total - discount;

        // Find the applicable rate for this subtotal
        let applicableRate = null;
        for (const rate of deliveryRates) {
            if (rate.active && subtotal >= parseFloat(rate.min_spend)) {
                if (!applicableRate || parseFloat(rate.min_spend) > parseFloat(applicableRate.min_spend)) {
                    applicableRate = rate;
                }
            }
        }

        // If no applicable rate found, use the base rate (min_spend = 0)
        if (!applicableRate) {
            applicableRate = deliveryRates.find(deliveryRate => deliveryRate.active && parseFloat(deliveryRate.min_spend) === 0) ||
                { rate: 55, min_spend: 0 };
        }

        return parseFloat(applicableRate.rate);
    }

    // Fallback to static calculation
    return total - discount < DELIVERY_THRESHOLD ? DELIVERY_COST : 0;
}

//for frontend
export function getSOStatus(status) {
    switch (status) {
        case 1:
            return "รอการชำระ/แจ้งการชำระ";
        case 2:
            return "กำลังตรวจสอบ";
        case 3:
            return "เตรียมจัดส่ง";
        case 13:
            return "กำลังจัดส่ง";
        case 14:
            return "กำลังจัดส่ง";
        case 15:
            return "ยกเลิก";
        case 17:
            return "สำเร็จ";
        case 98:
            return "เสร็จสิ้น (รอการรีวิว)"
        case 99:
            return "เสร็จสิ้น";
        default:
            return "";
    }
    // if (status === 1) {
    //     text = "Waiting for payment";
    // } else if (status === 2) {
    //     text = "Submitted a payment";
    // } else if (status === 3) {
    //     text = "Order Preparing";
    // } else if (status === 13) {
    //     text = "Packing";
    // } else if (status === 14) {
    //     text = "Shipped";
    // } else if (status === 15) {
    //     text = "Cancelled";
    // } else if (status === 17) {
    //     text = "Completed (COD)";
    // } else if (status === 99) {
    //     text = "Delivered / Completed";
    // }
    // return text;
}

export function renderFlag(code) {
    if (code === "th") {
        // g-ml-minus-10
        return (<img className="mr-1" src="https://lipis.github.io/flag-icon-css/flags/4x3/th.svg" alt="Thailand Flag" height="11" width="27" />);
    } else if (code === "en") {
        return (
            <svg className="mr-1" xmlns="http://www.w3.org/2000/svg" height="11" width="27" viewBox="0 0 640 480">
                <defs>
                    <clipPath id="a">
                        <path fillOpacity=".67" d="M-85.333 0h682.67v512h-682.67z" />
                    </clipPath>
                </defs>
                <g clipPath="url(#a)" transform="translate(80) scale(.94)">
                    <g strokeWidth="1pt">
                        <path fill="#006" d="M-256 0H768.02v512.01H-256z" />
                        <path d="M-256 0v57.244l909.535 454.768H768.02V454.77L-141.515 0H-256zM768.02 0v57.243L-141.515 512.01H-256v-57.243L653.535 0H768.02z" fill="#fff" />
                        <path d="M170.675 0v512.01h170.67V0h-170.67zM-256 170.67v170.67H768.02V170.67H-256z" fill="#fff" />
                        <path d="M-256 204.804v102.402H768.02V204.804H-256zM204.81 0v512.01h102.4V0h-102.4zM-256 512.01L85.34 341.34h76.324l-341.34 170.67H-256zM-256 0L85.34 170.67H9.016L-256 38.164V0zm606.356 170.67L691.696 0h76.324L426.68 170.67h-76.324zM768.02 512.01L426.68 341.34h76.324L768.02 473.848v38.162z" fill="#c00" />
                    </g>
                </g>
            </svg>
        );
    }
}

export function getVariantValue(item, type) {
    if (typeof item === "undefined" || !item) {
        return null;
    }
    else if (item.variant_type_1 !== null && item.variant_type_1.toLowerCase() === type.toLowerCase()) {
        return { name: item.variant_name_1, code: item.variant_code_1, sold_out: item.sold_out };
    }
    else if (item.variant_type_2 !== null && item.variant_type_2.toLowerCase() === type.toLowerCase()) {
        return { name: item.variant_name_2, code: item.variant_code_2, sold_out: item.sold_out };
    }
    else if (item.variant_type_3 !== null && item.variant_type_3.toLowerCase() === type.toLowerCase()) {
        return { name: item.variant_name_3, code: item.variant_code_3, sold_out: item.sold_out };
    }
    else if (item.variant_type_4 !== null && item.variant_type_4.toLowerCase() === type.toLowerCase()) {
        return { name: item.variant_name_4, code: item.variant_code_4, sold_out: item.sold_out };
    }
    else if (item.variant_type_5 !== null && item.variant_type_5.toLowerCase() === type.toLowerCase()) {
        return { name: item.variant_name_5, code: item.variant_code_5, sold_out: item.sold_out };
    }
    return { name: null, code: null };
    // return {name: null, code: null, sold_out: true};
}

export function getPromotionName(item, options = null) {
    let specialCase = false
    const promotions = item.promotion;
    const discount = item.discount; // for only p003
    const discount_type = item.discount_type//? item.discount_type: item.promotion_description? item.promotion_description[0]: null;
    if (!promotions && item.mat_price !== item.net_price) {
        specialCase = true;
    }
    if (typeof promotions === "undefined" && !specialCase) {
        return "";
    }
    if (promotions) {
        if (promotions.p001 === 1) {
            const data = discount_type ? discount_type.data : null;
            if (!discount_type) {
                return ``
            }
            return `${discount_type ? discount_type.min : ""} ชิ้น ${discount_type && data ? " ฿" + data[discount_type.min][0].sale_amt : "ถูกกว่า"}`;
        } else if (promotions.p002 === 1) {
            if (typeof item.pro_002 === "undefined" || !item.pro_002) {
                return "";
            }
            return "ชิ้นที่ " + item.pro_002.sale_qty + " ลด " + item.pro_002.disc + "%";
        } else if (promotions.p004 === 1) {
            const pro_004 = item.pro_004;
            // let ext = ``;
            if (pro_004) {
                // return `ซื้อ ${pro_004 ? pro_004.sale_qty : ""} แถม ${pro_004 ? pro_004.free_qty : ""}${ext}`; //x แถม y
                return `${pro_004 ? pro_004.sale_qty : ""} + ${pro_004 ? pro_004.free_qty : ""}`
            } else {
                return ``;
            }
        } else if (promotions.p005 === 1) {
            const pro_005 = item.pro_005;
            let detail = ``;
            let ext = `ถูกกว่า`;
            if (pro_005) {
                // if (pro_005.new_price) {
                //     ext = `ราคา ${pro_005.new_price} ฿`;
                // }
                detail = ` ${pro_005.sale_qty} ชิ้น`
                // if (pro_005.sale_qty === 2) {
                //     detail = "คู่"
                // }
                return `${detail}${ext}`; //x แถม y
            } else {
                return ``;
            }
        } else if (promotions.p006 === 1) {
            return `ซื้อครบลด ${item.pro_006.percent}%`
        }
    }
    if (specialCase || promotions.p003 === 1) {
        if (!specialCase && typeof discount === "undefined") {
            return "";
        }
        const net_price = item.net_price ? item.net_price : item.mat_price
        const saveValue = Math.round((item.mat_label_price - net_price) / item.mat_label_price * 100);
        let text = saveValue + " %";
        if (options && options.percent) {
            return "ลด\n" + text;
        }
        if (item.mat_label_price - net_price < 100) {
            if (saveValue === 0) {
                return null;
            }
            text = saveValue + "%";
        } else {
            text = "฿" + (item.mat_label_price - net_price);
        }
        return "ลด\n" + text;
    }
}

export function getPromotion(promotion, desc) {
    const promotion_desc = Array.isArray(desc) ? desc[0] : desc;
    if (!promotion || promotion === "") {
        return "";
    } else if (promotion === "p001") {
        return `${promotion_desc ? promotion_desc.pro_qty : ""} ชิ้น${promotion_desc.qty3up === 1 ? "ขึ้นไป" : ""}ราคา${promotion_desc ? " " + promotion_desc.pro_price + " ฿" : "พิเศษ"}`;
    } else if (promotion === "p002") {
        if (typeof promotion_desc === "undefined" || promotion_desc === "0") {
            return "";
        }
        return "ชิ้นที่ " + promotion_desc.sale_qty + " ลด " + promotion_desc.disc + "%";
    } else if (promotion === "p003") {
        return ``
    } else if (promotion === "p004") {
        let ext = ``;
        if (promotion_desc) {
            return `${promotion_desc ? promotion_desc.sale_qty : ""} แถม ${promotion_desc ? promotion_desc.free_qty : ""}${ext}`; //x แถม y
        } else {
            return ``;
        }
        // } else if (promotion === "p005") {
        //     let ext = ``;
        //     if (promotion_desc) {
        //         if (promotion_desc.new_price) {
        //             ext = ` ราคาพิเศษ`;
        //         }
        //         return `${promotion_desc ? promotion_desc.sale_qty : ""} แถม ${promotion_desc ? promotion_desc.free_qty : ""}${ext}`; //x แถม y
        //     } else {
        //         return ``;
        //     }
        // } else {
        //     return ``;
        // }
    } else if (promotion === "p005") {
        let detail = ``;
        let ext = "";
        if (promotion_desc) {
            detail = ` ${promotion_desc.sale_qty} ชิ้นในราคา`;
            if (promotion_desc.sale_qty === 2) {
                detail = `คู่ในราคา`;
            }
            ext = _.get(desc, "line_spec", 0) === 0 ? ` ${moneyFormat(promotion_desc.price, '฿')}` : `พิเศษ`;
            return `ซื้อ${detail}${ext}`;
        } else {
            return ``;
        }
    } else if (promotion === "p006" && promotion_desc) {
        return `ซื้อครบลด ${_.get(promotion_desc, "percent", null)}%`
    }
}

export function getJsonFromUrl(hashBased) {
    var query;
    var pos = hashBased.indexOf("?");
    if (pos === -1) return [];
    query = hashBased.substr(pos + 1);
    // if(hashBased) {

    // } else {
    //     query = location.search.substr(1);
    // }
    var result = {};
    query.split("&").forEach(function (part) {
        if (!part) return;
        part = part.split("+").join(" "); // replace every + with space, regexp-free version
        var eq = part.indexOf("=");
        var key = eq > -1 ? part.substr(0, eq) : part;
        var val = eq > -1 ? decodeURIComponent(part.substr(eq + 1)) : "";
        var from = key.indexOf("[");
        if (from === -1) result[decodeURIComponent(key)] = val;
        else {
            var to = key.indexOf("]", from);
            var index = decodeURIComponent(key.substring(from + 1, to));
            key = decodeURIComponent(key.substring(0, from));
            if (!result[key]) result[key] = [];
            if (!index) result[key].push(val);
            else result[key][index] = val;
        }
    });
    return result;
}

export function paddingZeros(num, length) {
    const zeros = '0'.repeat(length);
    const text = zeros + num;

    return text.substr(text.length - length, length);
}

export function validateEmail(email) {
    // eslint-disable-next-line
    var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
}

export function validateMobilePhone(mobile) {
    var re = /^[0-9]{9,10}$/;
    return re.test(mobile);
}

export function validateTaxId(taxId) {
    var re = /^[0-9]{13}$/;
    return re.test(taxId);
}

export function validatePassword(password) {
    return password.length >= 8;
}

export function validateDate(date) {
    const re = /^[0-9]{4}-[0-9]{2}-[0-9]{2} [0-2][0-9]:[0-5][0-9]:[0-5][0-9]$/
    if (re.test(date)) {
        return moment(date).isValid();
    }
    return false;
}

export function getErrorCode(error) {
    const err_code = error.response ? (error.response.data ? (error.response.data.code ? error.response.data.code : "ERROR.CODE_UNAVAILABLE") : "ERROR.CODE_UNAVAILABLE") : "ERROR.CODE_UNAVAILABLE";
    return err_code;
}

export function getFaceShape(id) {
    const face_shape = id;
    if (face_shape === 1) {
        return 'Face shape: Round';
    }
    else if (face_shape === 2) {
        return 'Face shape: Oblong';
    }
    else if (face_shape === 3) {
        return 'Face shape: Diamond';
    }
    else if (face_shape === 4) {
        return 'Face shape: Oval';
    }
    else if (face_shape === 5) {
        return 'Face shape: Heart';
    }
    else if (face_shape === 6) {
        return 'Face shape: Heart';
    }
}

export function getFacetype(id) {
    const face_type = id;
    if (face_type === 1) {
        return 'Face type: Dry';
    }
    else if (face_type === 2) {
        return 'Face type: Oily';
    }
    else if (face_type === 3) {
        return 'Face type: Mixed';
    }
    else if (face_type === 4) {
        return 'Face type: Normal';
    }
}

export function getFacetone(id) {
    const face_tone = id;
    if (face_tone === 1) {
        return 'Face tone: Pinky Fair';
    }
    else if (face_tone === 2) {
        return 'Face tone: Yellow Fair';
    }
    else if (face_tone === 3) {
        return 'Face tone: 2 Tones';
    }
    else if (face_tone === 4) {
        return 'Face tone: Copper';
    }
    else if (face_tone === 5) {
        return 'Face tone: Dark';
    }
}

export function getBodytone(id) {
    const body_tone = id;
    if (body_tone === 1) {
        return 'Body tone: White';
    }
    else if (body_tone === 2) {
        return 'Body tone: Pinky Fair';
    }
    else if (body_tone === 3) {
        return 'Body tone: Yellow Fair';
    }
    else if (body_tone === 4) {
        return 'Body tone: 2 Tones';
    }
    else if (body_tone === 5) {
        return 'Body tone: Copper';
    }
    else if (body_tone === 6) {
        return 'Body tone: Dark';
    }
}

export function getBodyType(id) {
    const body_type = id;
    if (body_type === 1) {
        return 'Body type: Dry';
    }
    else if (body_type === 2) {
        return 'Body type: Oily';
    }
    else if (body_type === 3) {
        return 'Body type: Normal';
    }
}

export function getHairtype(id) {
    const hair_type = id;
    if (hair_type === 1) {
        return 'Hair type: Thin';
    }
    else if (hair_type === 2) {
        return 'Hair type: Thick';
    }
    else if (hair_type === 3) {
        return 'Hair type: Straight';
    }
    else if (hair_type === 4) {
        return 'Hair type: Curl';
    }
    else if (hair_type === 5) {
        return 'Hair type: Chamical Used (type changing)';
    }
}

export function getEventSummary(eventName, eventCode, deliveryDate = null) {
    if (!eventName) return null
    if (eventName.toLowerCase() === "valentine") {
        if (eventCode === 1 && deliveryDate === 1) {
            return { name: "Valentine", deliver: "13 ก.พ. 2562", type: "S" }
        } else if (eventCode === 1 && deliveryDate === 2) {
            return { name: "Valentine", deliver: "14 ก.พ. 2562", type: "S" }
        } else if (eventCode === 2 && deliveryDate === 1) {
            return { name: "Valentine", deliver: "13 ก.พ. 2562", type: "L" }
        }
        else if (eventCode === 2 && deliveryDate === 2) {
            return { name: "Valentine", deliver: "14 ก.พ. 2562", type: "L" }
        }
    }
}

export function gtm(action, params, callback) {
    // Use consent-aware tracking
    return gtmWithConsent(action, params, callback);
}

// Carousel banner tracking functions
export function trackBannerImpression(banner, position, totalBanners) {
    const params = {
        event_category: 'Banner',
        event_label: 'Home Carousel',
        banner_id: banner.id || 'unknown',
        banner_title: banner.title || banner.name || 'unknown',
        banner_link: banner.link || 'unknown',
        banner_position: position + 1,
        total_banners: totalBanners,
        banner_type: banner.external_link ? 'external' : 'internal',
        timestamp: new Date().toISOString()
    }

    gtm('banner_impression', params)
}

export function trackBannerClick(banner, position, totalBanners) {
    const params = {
        event_category: 'Banner',
        event_label: 'Home Carousel',
        banner_id: banner.id || 'unknown',
        banner_title: banner.title || banner.name || 'unknown',
        banner_link: banner.link || 'unknown',
        banner_position: position + 1,
        total_banners: totalBanners,
        banner_type: banner.external_link ? 'external' : 'internal',
        timestamp: new Date().toISOString()
    }

    gtm('banner_click', params)
}

export function trackCarouselSlideChange(currentSlide, totalSlides, direction) {
    const params = {
        event_category: 'Carousel',
        event_label: 'Home Carousel',
        current_slide: currentSlide + 1,
        total_slides: totalSlides,
        direction: direction, // 'prev' or 'next'
        timestamp: new Date().toISOString()
    }

    gtm('carousel_slide_change', params)
}

// Category tracking functions
export function trackCategoryImpression(category, position, totalCategories) {
    const params = {
        event_category: 'Category',
        event_label: 'Home Categories',
        category_id: category.id || 'unknown',
        category_title_en: category.title_en || 'unknown',
        category_title_th: category.title_th || 'unknown',
        category_link: category.link || 'unknown',
        category_position: position + 1,
        total_categories: totalCategories,
        category_type: 'main_category',
        timestamp: new Date().toISOString()
    }

    gtm('category_impression', params)
}

export function trackCategoryClick(category, position, totalCategories) {
    const params = {
        event_category: 'Category',
        event_label: 'Home Categories',
        category_id: category.id || 'unknown',
        category_title_en: category.title_en || 'unknown',
        category_title_th: category.title_th || 'unknown',
        category_link: category.link || 'unknown',
        category_position: position + 1,
        total_categories: totalCategories,
        category_type: 'main_category',
        timestamp: new Date().toISOString()
    }

    gtm('category_click', params)
}

export function trackCategorySectionImpression(categories) {
    const params = {
        event_category: 'Category',
        event_label: 'Home Categories',
        total_categories: categories ? categories.length : 0,
        section_type: 'category_grid',
        timestamp: new Date().toISOString()
    }

    gtm('category_section_impression', params)
}

// Best Seller tracking functions
export function trackBestSellerImpression(product, position, totalProducts) {
    const params = {
        event_category: 'Product',
        event_label: 'Best Seller',
        product_id: product.mat_id || 'unknown',
        product_name: product.mat_name || 'unknown',
        product_brand: product.brand_en || 'unknown',
        product_price: product.net_price || product.mat_price || 0,
        product_original_price: product.mat_label_price || product.mat_price || 0,
        product_position: position + 1,
        total_products: totalProducts,
        product_type: 'best_seller',
        product_rank: position + 1,
        timestamp: new Date().toISOString()
    }

    gtm('best_seller_impression', params)
}

export function trackBestSellerClick(product, position, totalProducts) {
    const params = {
        event_category: 'Product',
        event_label: 'Best Seller',
        product_id: product.mat_id || 'unknown',
        product_name: product.mat_name || 'unknown',
        product_brand: product.brand_en || 'unknown',
        product_price: product.net_price || product.mat_price || 0,
        product_original_price: product.mat_label_price || product.mat_price || 0,
        product_position: position + 1,
        total_products: totalProducts,
        product_type: 'best_seller',
        product_rank: position + 1,
        timestamp: new Date().toISOString()
    }

    gtm('best_seller_click', params)
}

export function trackBestSellerSectionImpression(products) {
    const params = {
        event_category: 'Product',
        event_label: 'Best Seller',
        total_products: products ? products.length : 0,
        section_type: 'best_seller_grid',
        timestamp: new Date().toISOString()
    }

    gtm('best_seller_section_impression', params)
}

// Recommend section tracking functions
export function trackRecommendImpression(content, position, totalContents, sectionTitle) {
    const params = {
        event_category: 'Recommend',
        event_label: 'Home Recommend',
        content_id: content.id || 'unknown',
        content_title: content.title || content.name || 'unknown',
        content_link: content.link || 'unknown',
        content_position: position + 1,
        total_contents: totalContents,
        content_type: content.external_link ? 'external' : 'internal',
        section_title: sectionTitle || 'unknown',
        layout_type: content.__component || 'unknown',
        timestamp: new Date().toISOString()
    }

    gtm('recommend_impression', params)
}

export function trackRecommendClick(content, position, totalContents, sectionTitle) {
    const params = {
        event_category: 'Recommend',
        event_label: 'Home Recommend',
        content_id: content.id || 'unknown',
        content_title: content.title || content.name || 'unknown',
        content_link: content.link || 'unknown',
        content_position: position + 1,
        total_contents: totalContents,
        content_type: content.external_link ? 'external' : 'internal',
        section_title: sectionTitle || 'unknown',
        layout_type: content.__component || 'unknown',
        timestamp: new Date().toISOString()
    }

    gtm('recommend_click', params)
}

export function trackRecommendSectionImpression(contents, sectionTitle) {
    const params = {
        event_category: 'Recommend',
        event_label: 'Home Recommend',
        total_contents: contents ? contents.length : 0,
        section_title: sectionTitle || 'unknown',
        section_type: 'recommend_grid',
        timestamp: new Date().toISOString()
    }

    gtm('recommend_section_impression', params)
}


export function getCategoryFromItem(item, categories) {
    const { cat1_id, cat2_id, cat3_id } = item
    const cat1 = _.find(categories, (c) => c.cat1_id === cat1_id);
    const cat2 = cat1 ? _.find(cat1.subCategories, (c) => c.cat1_id === cat1_id && c.cat2_id === cat2_id) : null;
    const cat3 = cat2 ? _.find(cat2.subCategories, (c) => c.cat1_id === cat1_id && c.cat2_id === cat2_id && c.cat3_id === cat3_id) : null;

    return { cat1: cat1 ? cat1.category : '', cat2: cat2 ? cat2.category : '', cat3: cat3 ? cat3.category : '' }
}
export function generateGTMItemValue(tempItem, quantity, valueDefined = null, categories) {
    const item = tempItem.info ? tempItem.info : tempItem;
    const net_price = item.net_price || item.mat_price;
    const size = getVariantValue(item, "Volume") ? getVariantValue(item, "Volume").name : null
    const { cat1, cat2, cat3 } = getCategoryFromItem(item, categories)
    const gtmValue = {
        value: valueDefined !== null ? valueDefined : net_price * quantity,
        currency: 'THB',
        items: [{
            brand: item.brand_en,
            id: item.item_id,
            name: item.mat_name + (size ? ' ' + size : '') + (item.variant_2 ? ' ' + item.variant_2 : ''),
            quantity: quantity,
            price: net_price,
            category: `${cat1}/${cat2}/${cat3}`
        }]
    }

    return gtmValue;
}

export function getCategoryName(category, categories) {
    const { cat1_id, cat2_id, cat3_id } = category
    const cat1 = _.find(categories, (c) => c.cat1_id === cat1_id);
    const cat2 = cat1 ? _.find(cat1.subCategories, (c) => c.cat1_id === cat1_id && c.cat2_id === cat2_id) : null
    const cat3 = cat2 ? _.find(cat2.subCategories, (c) => c.cat1_id === cat1_id && c.cat2_id === cat2_id && c.cat3_id === cat3_id) : null

    return { cat1: cat1 ? cat1.category : '', cat2: cat2 ? cat2.category : '', cat3: cat3 ? cat3.category : '' }
}

export function getVariantGroupName(variant_group) {
    switch (variant_group) {
        case 'Colour':
            return 'เฉดสี'
        case 'Scent':
            return 'กลิ่น'
        case 'Visual Acuity':
            return 'ค่าสายตา'
        default:
            return ''
    }
}

export function diff(obj1, obj2, path = {}) {
    obj1 = obj1 || {};
    obj2 = obj2 || {};

    return _.reduce(obj1, function (result, value, key) {
        var p = path ? path + '.' + key : key;
        if (_.isObject(value)) {
            var d = diff(value, obj2[key], p);
            return d.length ? result.concat(d) : result;
        }
        return _.isEqual(value, obj2[key]) ? result : result.concat(p);
    }, []);
}

export function pixelAddToCart(product, qty) {
    const net_price = product.net_price || product.mat_price || product.mat_label_price
    const params = {
        value: qty * net_price,
        currency: 'THB',
        content_type: 'product',
        content_category: `${product.brand_en}-${product.cat1_id}-${product.cat2_id}-${product.cat3_id}`,
        contents: [
            {
                id: product.item_id,
                quantity: qty
            }
        ]
    }
    pixelTrack('AddToCart', params)
}

export function pixelAddToWishList(product) {
    const net_price = product.net_price || product.mat_price || product.mat_label_price
    const params = {
        value: net_price,
        currency: 'THB',
        content_type: 'product',
        content_ids: product.item_id,
        content_category: `${product.brand_en}-${product.cat1_id}-${product.cat2_id}-${product.cat3_id}`,
    }
    pixelTrack('AddToWishlist', params)
}

// Cookie consent aware tracking function
export function pixelTrack(eventName, params) {
    // Check if marketing cookies are allowed
    if (isCookieCategoryAllowed && !isCookieCategoryAllowed('marketing')) {
        console.log('Marketing tracking disabled due to cookie consent');
        return;
    }

    /* eslint-disable */
    if (fbq) {
        if (params) {
            fbq('track', eventName, params)
        } else {
            fbq('track', eventName)
        }
    }
    /* eslint-enable */
}

// Cookie consent aware GTM tracking
export function gtmWithConsent(action, params, callback) {
    // Check if analytics cookies are allowed
    if (isCookieCategoryAllowed && !isCookieCategoryAllowed('analytics')) {
        console.log('Analytics tracking disabled due to cookie consent');
        return;
    }

    /* eslint-disable */
    if (gtag) {
        gtag('event', action, params)
    }
    /* eslint-enable */
}

export function createURLFromFilter(filter, oldQuery, categories, currentLanguage) {
    let url = "/shop"

    if (filter.brand_en && filter.brand_en !== "") {
        url += "/" + filter.brand_en
    }
    let cat1, cat2;
    if (filter.cat1_id) {
        cat1 = _.find(categories, (c) => c.cat1_id === filter.cat1_id)
        url += "/" + slugify(cat1.category, { lower: true })
    }

    if (cat1 && filter.cat2_id) {
        cat2 = _.find(cat1.subCategories, (c) => c.cat2_id === filter.cat2_id && c.cat1_id === filter.cat1_id)
        url += "/" + slugify(cat2.category, { lower: true })
    }

    if (cat1 && cat2 && filter.cat3_id) {
        const cat3 = _.find(cat2.subCategories, (c) => c.cat1_id === filter.cat1_id && c.cat2_id === filter.cat2_id && c.cat3_id === filter.cat3_id)
        url += "/" + slugify(cat3.category, { lower: true })
    }

    let query = oldQuery ? QueryString.parse(oldQuery) : {};
    if (filter.promotion) {
        const proValue = _.map(filter.promotion, (p) => p ? 1 : 0).join("-")
        //queryString += "promotion=" + proValue
        query.promotion = proValue;
    }

    if (Array.isArray(filter.mat_var_id)) {
        const productValue = filter.mat_var_id.join(",")
        // queryString += "products=" + productValue
        query.products = productValue;
    }

    if (filter.origin) {
        // queryString += "origin=" + filter.origin
        query.origin = filter.origin;
    }

    if (filter.keyword) {
        query.keyword = filter.keyword;
    }

    if (filter.event) {
        query.event = filter.event;
    }

    return { url, queryString: QueryString.stringify(query) }
}

export function renderDateDuration(start, end, showYear = true, monthFormat = "MMMM") {
    const s = moment(start)
    const e = moment(end)
    s.locale("en");
    e.locale("en");
    if (s.isSame(e, 'M')) {
        return `${s.format("DD")} - ${e.format("DD")} ${s.format(monthFormat)}${showYear ? " " + s.format("YYYY") : ""}`
    } else {
        return `${s.format("DD")} ${s.format(monthFormat)} - ${e.format("DD")} ${e.format(monthFormat)}${showYear ? " " + s.format("YYYY") : ""}`
    }
}

export function ImageWebP(props) {
    const { src, mobileSrc, mobile, name, media, style, className, ...rest } = props;
    var canUseDOM = !!(
        (typeof window !== 'undefined' &&
            window.document && window.document.createElement)
    );
    if (!src || typeof src !== "string") {
        return <img src="" alt={name} />;
    }
    const isBrowserSupportWebP = canUseDOM ? canUseWebP() : true;
    const match = src.match(/(.*)\/(.*)\.(.*)/);
    const ext = match[3];
    const webp = src.replace(ext, 'webp').replace('s3.ap-southeast-1.amazonaws.com/', '');
    const newSrc = src.replace('s3.ap-southeast-1.amazonaws.com/', '');
    let newMobileSrc = mobileSrc;
    let match2, ext2, mobileWebp
    if (mobile) {
        if (!mobileSrc) {
            return (
                <img src={isBrowserSupportWebP ? webp : newSrc} alt={name} style={style || { width: "100%" }} className={className || null} {...rest} />
            );
        }
        match2 = mobileSrc.match(/(.*)\/(.*)\.(.*)/);
        ext2 = match2[3];
        mobileWebp = mobileSrc.replace(ext2, 'webp').replace('s3.ap-southeast-1.amazonaws.com/', '');
        newMobileSrc = mobileSrc.replace('s3.ap-southeast-1.amazonaws.com/', '');
    }

    if (mobile) {
        return (
            <picture {...rest}>
                <source srcSet={isBrowserSupportWebP ? mobileWebp : newMobileSrc} media={media || "(max-width: 767px) and (orientation: portrait)"} />
                <img src={isBrowserSupportWebP ? webp : newSrc} alt={name} style={style || { width: "100%" }} />
            </picture>
        )
    }
    return (
        <img src={isBrowserSupportWebP ? webp : newSrc} alt={name} style={style || { width: "100%" }} className={className || null} {...rest} />
    );
}